const doc = [({"zh_cn":({"adminConstantBankDepositType":({"checkingAccount":"支票账户", "ordinaryDeposit":"普通存款"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;